<template>
    <div v-if="upsellPackages.length > 0">
        <div class="card-header border-top">
            <div class="row align-items-center">
                <div class="col-auto"><i class="fal fa-box-full text-primary fa-2x"></i></div>
                <div class="col pl-0"><h5 class="mb-0 font-weight-normal">{{ $t("upselling.title") }}</h5></div>
            </div>
        </div>
        <div class="card-body">
            <UpsellPackage
                v-for="(upsellPackage, idx) in upsellPackages"
                :key="upsellPackage.uuid"
                :upsellPackage="upsellPackage"
                :class="{'pb-2 mb-2': idx < upsellPackages.length - 1}"
                @removed="upsellPackages.splice(idx, 1)"
            />
        </div>
    </div>
</template>

<script>

import UpsellPackage from "./Upselling/UpsellPackage";

export default {
    name: "Upselling",
    data() {
        return {
            upsellPackages: []
        }
    },
    mounted() {
        this.fetchUpsellPackages();
    },
    methods: {
        fetchUpsellPackages()
        {
            axios.get(tebex.application.basketApi + "/upsells").then(response => {
                this.upsellPackages = response.data.data;
            });
        },
    },
    components: {
        UpsellPackage
    }
}
</script>
